module.exports = __webpack_public_path__ + "static/img/ser-b-2.cb46179.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/setmeal/ser-b-2.png
// module id = 7LrS
// module chunks = 1